module.exports = __webpack_public_path__ + "static/media/site-intro.db9967f1.webp";